import { render, staticRenderFns } from "./rich-message.vue?vue&type=template&id=79d4c80d&scoped=true"
import script from "./rich-message.vue?vue&type=script&lang=js"
export * from "./rich-message.vue?vue&type=script&lang=js"
import style0 from "./rich-message.vue?vue&type=style&index=0&id=79d4c80d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d4c80d",
  null
  
)

export default component.exports